export default "__VITE_ASSET__4739e667__"